module.exports = __webpack_public_path__ + "assets/img/066679952e444e4f554c4a8e9f035b47.png";